/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-01, 14:29:05
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import { mapActions, mapGetters } from 'vuex';
import MobileMenuList from '@/components/Panel/TopMenu/MobileMenuList';
import { getMenuScheme, visibilityDependOnAcl, visibilityDependOnAccountTypes, visibilityJustOnMobile } from '@/components/Panel/MenuCommon';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'TopMenu',

  components: { MobileMenuList },

  props: ['subscriber', 'brandLogos'],

  data() {
    return {
      currentPageTitleMap: {
        MyAccount: 'Twoje konto',
        Recharges: 'Doładowania',
        PaymentsAndInvoices: 'Płatności',
        Billing: 'Historia połączeń',
        Complains: 'Kontakt',
        Help: 'Pomoc',
        Logout: 'Wyloguj się',
        Services: 'Usługi',
      },
      menuIcon: require('@/assets/hamburger.svg')
    };
  },

  computed: {
    ...mapGetters(['mobileMenuIsVisible', 'acl', 'brandId', 'selectedCategory']),
    availableMenu() {
      return getMenuScheme().map(menu => ({
        ...menu,
        isVisible:
          visibilityDependOnAcl(this, menu)
          && visibilityDependOnAccountTypes(this, menu)
          && visibilityJustOnMobile(this, menu),
      }));
    },
  },

  methods: {
    ...mapActions(['logOut', 'showMobileMenuList', 'hideMobileMenuList']),
    goto(pathObject) {
      const { name, params } = pathObject;
      this.$router.push({ name, params });
    },
    changeUrl(pathObject) {
      const { name, params } = pathObject;
      if (name == 'Logout') {
        this.submitLogOut();
        return;
      }
      this.$router.push({ name, params }, () => {
        if (this.mobileMenuIsVisible) {
          this.toggleMenu();
        }
      });
    },
    toggleMenu() {
      if (this.mobileMenuIsVisible) {
        this.hideMobileMenuList();
      } else {
        this.showMobileMenuList();
      }
    },
    submitLogOut() {
      this.logOut()
        .then(() => {
          window.location.reload();
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Panel/TopMenu/component.js